import { render } from "./GreenBody.vue?vue&type=template&id=5f3d16d0&scoped=true"
const script = {}

import "./GreenBody.vue?vue&type=style&index=0&id=5f3d16d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3d16d0"]])

export default __exports__